import { Record, Union } from "../../fable_modules/fable-library.3.7.20/Types.js";
import { record_type, option_type, class_type, int32_type, string_type, union_type } from "../../fable_modules/fable-library.3.7.20/Reflection.js";
import { toText, printf, toFail } from "../../fable_modules/fable-library.3.7.20/String.js";
import { ProductModule_ofInt, ProductModule_toInt, Product$reflection } from "../../DomainTypes.js";
import { DateFormatModule_toyyyyMMdd } from "../../Svea.Dry/Time.js";

export class SubproductLevel extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["Client", "ContractType", "PriceList", "Contract"];
    }
}

export function SubproductLevel$reflection() {
    return union_type("Containers.Subproducts.Model.SubproductLevel", [], SubproductLevel, () => [[], [], [], []]);
}

export function SubproductLevel_get_ofString() {
    return (_arg) => ((_arg === "Client") ? (new SubproductLevel(0)) : ((_arg === "ContractType") ? (new SubproductLevel(1)) : ((_arg === "PriceList") ? (new SubproductLevel(2)) : ((_arg === "Contract") ? (new SubproductLevel(3)) : toFail(printf("Could not parse SubproductLevel from: %s"))(_arg)))));
}

export function SubproductLevel_get_toString() {
    return (_arg) => ((_arg.tag === 1) ? "ContractType" : ((_arg.tag === 2) ? "PriceList" : ((_arg.tag === 3) ? "Contract" : "Client")));
}

export function SubproductLevel_toTranslation_11D407F6(getTranslation) {
    return (_arg) => ((_arg.tag === 1) ? getTranslation("Common.ContractType") : ((_arg.tag === 2) ? getTranslation("Common.PriceList") : ((_arg.tag === 3) ? getTranslation("Common.Subscription") : "Client")));
}

export class GenericSubproductDTO extends Record {
    constructor(SubproductName, ProductNr, ActiveFrom, ActiveTo, SortOrder, SubproductLevel) {
        super();
        this.SubproductName = SubproductName;
        this.ProductNr = (ProductNr | 0);
        this.ActiveFrom = ActiveFrom;
        this.ActiveTo = ActiveTo;
        this.SortOrder = SortOrder;
        this.SubproductLevel = SubproductLevel;
    }
}

export function GenericSubproductDTO$reflection() {
    return record_type("Containers.Subproducts.Model.GenericSubproductDTO", [], GenericSubproductDTO, () => [["SubproductName", string_type], ["ProductNr", int32_type], ["ActiveFrom", class_type("System.DateOnly")], ["ActiveTo", option_type(class_type("System.DateOnly"))], ["SortOrder", option_type(int32_type)], ["SubproductLevel", string_type]]);
}

export class NormalizedSubproduct extends Record {
    constructor(Id, Name, Product, ActiveFrom, ActiveTo, SortOrder, SubproductLevel) {
        super();
        this.Id = Id;
        this.Name = Name;
        this.Product = Product;
        this.ActiveFrom = ActiveFrom;
        this.ActiveTo = ActiveTo;
        this.SortOrder = SortOrder;
        this.SubproductLevel = SubproductLevel;
    }
}

export function NormalizedSubproduct$reflection() {
    return record_type("Containers.Subproducts.Model.NormalizedSubproduct", [], NormalizedSubproduct, () => [["Id", string_type], ["Name", string_type], ["Product", Product$reflection()], ["ActiveFrom", class_type("System.DateOnly")], ["ActiveTo", option_type(class_type("System.DateOnly"))], ["SortOrder", option_type(int32_type)], ["SubproductLevel", SubproductLevel$reflection()]]);
}

export function NormalizedSubproduct_toSubproductDTO_Z60DB963E(s) {
    return new GenericSubproductDTO(s.Name, ProductModule_toInt(s.Product), s.ActiveFrom, s.ActiveTo, s.SortOrder, SubproductLevel_get_toString()(s.SubproductLevel));
}

export function NormalizedSubproduct_ofSubproductDTO_Z9763C53(dto) {
    let arg_2;
    return new NormalizedSubproduct((arg_2 = DateFormatModule_toyyyyMMdd(dto.ActiveFrom), toText(printf("%s-%i-%s"))(dto.SubproductName)(dto.ProductNr)(arg_2)), dto.SubproductName, ProductModule_ofInt(dto.ProductNr), dto.ActiveFrom, dto.ActiveTo, dto.SortOrder, SubproductLevel_get_ofString()(dto.SubproductLevel));
}

